// 公共
export const SupplyRouterName = {
  /** 入库单管理 */
  InboundOrder: '/supply/inventory/inbound_order/list',
  /** 新增入库单 */
  InboundOrderAdd: '/supply/inventory/inbound_order/add',
  /** 编辑入库单 */
  InboundOrderEdit: '/supply/inventory/inbound_order/edit',
  /** 入库单详情 */
  InboundOrderDetail: '/supply/inventory/inbound_order/detail',
  /** 入库单打印 */
  InboundOrderPrint: '/supply/inventory/inbound_order/print',
  /** 售后单 */
  AfterSales: '/supply/after_sales/list',
  /** 售后单详情 */
  AfterSalesDetail: '/supply/after_sales/detail',
  /**
   * 售后单打印
   */
  AfterSalesPrint: '/supply/after_sales/print',
  /**
   * 采购单详情
   */
  PurchaseOrderDetail: '/supply/purchase_order/detail',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  StatementDetail: '/supply/bill/reconciliation/detail',
  /** 折扣定价单 */
  DiscountPriceList: '/supply/inquiry_quotation/discount_price/list',
  /** 折扣定价单详情 */
  DiscountPricesDetail: '/supply/inquiry_quotation/discount_price/detail',

  /** 商品行情价 */
  MarketPriceList: '/supply/inquiry_quotation/market_price/list',
  /** 商品行情价详情 */
  MarketPricesDetail: '/supply/inquiry_quotation/market_price/detail',
  /** 商品行情价编辑 */
  MarketPricesEdit: '/supply/inquiry_quotation/market_price/edit',
  /** 商品行情价创建 */
  MarketPricesCreate: '/supply/inquiry_quotation/market_price/create',
  /** 行情价汇聚 */
  MarketPriceGatherList: '/supply/inquiry_quotation/market_price_gather/list',

  /** 折扣定价单公示列表 */
  DiscountPricesPublic: '/supply/report/discount_price_public/list',
  /** 折扣定价单公示结果 */
  DiscountPricesResult: '/supply/report/discount_price_public/result',

  /** 司机绩效 */
  DriverPerformanceList: '/supply/driver_performance/list',

  /** 行车报警 */
  VehicleAlarmList: '/supply/vehicle_alarm/list',

  /** 配送任务 */
  ManageDeliveryTaskList: '/supply/delivery_task/list',

  /** 合同详情 */
  PublicPurchaserContractDetail: '/supply/report/discount_price_public/contract_detail',

  /** 现场监控 */
  LiveMonitor: '/supply/live_monitor/list',
  /** 现场监控全屏 */
  LiveMonitorFullScreen: '/supply/live_monitor/full_screen',
  /** 违规记录 */
  VolationRecordList: '/supply/live_monitor/violation_record/list',

  /** 执行台账记录 */
  ExecutionRecordList: '/supply/execution_record/list',
  /** 执行台账记录详情 */
  ExecutionRecordDetail: '/supply/execution_record/detail',

  /** 验收标准详情 */
  AcceptanceCriteriaDetail: '/supply/acceptance_criteria/detail',

  /** 采购评价 */
  PurchaseEvaluateList: '/supply/report/purchase_evaluate/list',
  /** 采购单 */
  PurchaseOrderList: '/supply/purchase_order/list',
  /** 整改记录 */
  RectificationRecordList: '/supply/rectification_record/list',
  /** 售后明细 */
  AfterSaleDetailReportList: '/supply/report/after_sale_detail_report/list',
  /** 对账明细表 */
  StatementDetailReportList: '/supply/report/statement_detail_report/list',
  /** 回单记录 */
  ReturnReceiptRecordList: '/supply/return_receipt_record/list',
  /** 采购进度 */
  PurchaseProgressList: '/supply/purchase_progress/list',
  /** 查看答卷 */
  ExaminationExamAnswerDetail: '/supply/examination/exam_answer_detail',
  /** 答题 */
  ExaminationExamAnswer: '/supply/examination/exam_answer',
  /** IO记录 */
  IoRecordList: '/supply/io_record/list',
  /** 代分拣 */
  ReplaceSortingList: '/supply/replace_sorting/list',
  /** 委外收入列表 */
  OutsourceIncomeList: '/supply/outsource/income/list',
  /** 出库单管理 */
  OutboundOrder: '/supply/inventory/outbound_order/list',
  /** 新增出库单 */
  OutboundOrderAdd: '/supply/inventory/outbound_order/add',
  /** 编辑出库单 */
  OutboundOrderEdit: '/supply/inventory/outbound_order/edit',
  /** 出库单详情 */
  OutboundOrderDetail: '/supply/inventory/outbound_order/detail',
  /** 出库单打印 */
  OutboundOrderPrint: '/supply/inventory/outbound_order/print',
  /** 仓库列表 */
  WarehouseList: '/supply/warehouse/list',
  /** 申领单管理 */
  RequisitionOrder: '/supply/inventory/requisition/list',
  /** 新增申领单 */
  RequisitionOrderAdd: '/supply/inventory/requisition/add',
  /** 编辑申领单 */
  RequisitionOrderEdit: '/supply/inventory/requisition/edit',
  /** 申领单详情 */
  RequisitionOrderDetail: '/supply/inventory/requisition/detail',
  /** 申领单完成 */
  RequisitionOrderComplete: '/supply/inventory/requisition/complete',
  /** 申领单打印 */
  RequisitionOrderPrint: '/supply/inventory/requisition/print',
  /** 盘点单管理 */
  InventorySheet: '/supply/inventory/inventory_sheet/list',
  /** 新增盘点单 */
  InventorySheetAdd: '/supply/inventory/inventory_sheet/add',
  /** 编辑盘点单 */
  InventorySheetEdit: '/supply/inventory/inventory_sheet/edit',
  /** 盘点单详情 */
  InventorySheetDetail: '/supply/inventory/inventory_sheet/detail',
  /** 盘点 */
  InventorySheetInventory: '/supply/inventory/inventory_sheet/inventory',
  /** 过账 */
  InventorySheetPosted: '/supply/inventory/inventory_sheet/posted',
  /** 物料转换单管理 */
  MaterialConversion: '/supply/inventory/material_conversion/list',
  /** 新增物料转换单 */
  MaterialConversionAdd: '/supply/inventory/material_conversion/add',
  /** 编辑物料转换单 */
  MaterialConversionEdit: '/supply/inventory/material_conversion/edit',
  /** 物料转换单详情 */
  MaterialConversionDetail: '/supply/inventory/material_conversion/detail',
  /** 批量物料转换 */
  MaterialConversionBatchAdd: '/supply/inventory/material_conversion/batch_add',
  /** 库存台账 */
  InventoryLedger: '/supply/inventory/inventory_ledger/list',
  /** 实时库存 */
  RealInventory: '/supply/inventory/real_inventory',
  /** 需方画像 */
  PurchaserPortrait: '/supply/purchaser_portrait/list',
};

/** 供方平台路由 */
export const supplyRoutes = {
  /** 收据 */
  SupplyReceipt: '/supply/platform/receipt/list',
  /** 利润核算 */
  SupplyPurchaseOrderProfitAccountingList: '/supply/purchase_order/profit_accounting/list',
  /** 委外任务 */
  SupplyOutsourceTaskList: '/supply/outsource_task/list',
  /** 委外收入列表 */
  SupplyOutsourceIncomeList: '/supply/outsource/income/list',
  /** 成本记录列表 */
  SupplyCostRecordList: '/supply/purchase_order/cost_record/list',
  /** 新品提报 */
  SupplyNewSubmissionList: '/supply/commodity/new_submission/list',
  /** 质检报告（批次） */
  SupplyQualityInspectionBatchList: '/supply/commodity/quality_inspection_batch/list',
  /** 质检报告（批次）详情 */
  SupplyQualityInspectionBatchDetail: '/supply/commodity/quality_inspection_batch/detail',
  /** 上传质检报告 */
  SupplyQualityInspectionBatchCreate: '/supply/commodity/quality_inspection_batch/create',
  /** 编辑质检报告（批次） */
  SupplyQualityInspectionBatchEdit: '/supply/commodity/quality_inspection_batch/edit',
  /** 采购商品备注 */
  SupplyPurchaseSkuRemarkList: '/supply/purchase_order/purchase_sku_remark/list',
  /** 采购明细表 */
  SupplyPurchaseDetailReportList: '/supply/report/purchase_detail_report/list',
  /** 库存明细表 */
  SupplyStockDetailReportList: '/supply/report/stock_detail_report/list',
  /** 库存损耗表 */
  SupplyInventoryLossReportList: '/supply/report/inventory_loss_report/list',
  /** 配送损耗表 */
  SupplyDeliveryLossReportList: '/supply/report/delivery_loss_report/list',
  /** 项目公示列表 */
  SupplyProjectPublicList: '/supply/report/project_public/list',
  /** 项目公示结果 */
  SupplyProjectPublicResult: '/supply/report/project_public/result',
  /** 项目列表 */
  SupplyProjectManageList: '/supply/inquiry_quotation/project_manage/list',
  /** 项目详情 */
  SupplyProjectManageDetail: '/supply/inquiry_quotation/project_manage/detail',
  /** 项目详情-单号查询 */
  SupplyProjectManageDetailByNo: '/supply/inquiry_quotation/project_manage/detail_no',
  /** 滞销品列表 */
  SupplyDeadStockList: '/supply/commodity/dead_stock/list',
  /** 商品税率 */
  SupplyTaxRateList: '/supply/commodity/tax_rate/list',
  /** 报餐记录 */
  SupplyMealRecordList: '/supply/purchase_order/meal_record/list',
  /** 报餐记录详情 */
  SupplyMealRecordDetail: '/supply/purchase_order/meal_record/detail',
  /** 套餐需求汇总 */
  SupplyPackageSummaryList: '/supply/purchase_order/package_summary/list',
  /** 套餐管理 */
  SupplyPackageManageList: '/supply/commodity/package_manage/list',
  /** 新建套餐 */
  SupplyPackageManageCreate: '/supply/commodity/package_manage/create',
  /** 套餐详情 */
  SupplyPackageManageDetail: '/supply/commodity/package_manage/detail',
  /** 套餐编辑 */
  SupplyPackageManageEdit: '/supply/commodity/package_manage/edit',
  /** 财务汇总表 */
  SupplyFinancialReportList: '/supply/report/financial_report/list',
  /** 询价公示 */
  SupplyInquiryPublic: '/supply/report/inquiry_public/list',
  /** 公示结果 */
  SupplyPublicResult: '/supply/report/inquiry_public/result',
  /** 收支管理 */
  SupplyIncomeExpenseList: '/supply/bill/income_expense/list',
  /** 周转筐管理 */
  SupplyTurnoverBasketList: '/supply/turnover_basket/list',
  /** 周转筐详情 */
  SupplyTurnoverBasketDetail: '/supply/turnover_basket/detail',
  /** 新建周转筐借还记录 */
  SupplyTurnoverBasketCreate: '/supply/turnover_basket/create',
  /** 编辑周转筐借还记录 */
  SupplyTurnoverBasketEdit: '/supply/turnover_basket/edit',
  /** 周转筐统计 */
  SupplyBasketStatisticsList: '/supply/basket_statistics/list',
  /** 员工管理 */
  SupplierEmployeeList: '/supply/setting/employee/list',
  /** 商品列表 */
  SupplyUnsuperviseCommodityList: '/supply/unsupervise_commodity/list',
  /** 创建商品 */
  SupplyUnsuperviseCommodityCreate: '/supply/unsupervise_commodity/create',
  /** 编辑商品 */
  SupplyUnsuperviseCommodityUpdate: '/supply/unsupervise_commodity/update',
  /** 商品详情 */
  SupplyUnsuperviseCommodityDetail: '/supply/unsupervise_commodity/detail',
  /** 采购单编辑 */
  SupplyPurchaseOrderEdit: '/supply/purchase_order/edit',
  /** 采购单新增 */
  SupplyPurchaseOrderCreate: '/supply/purchase_order/create',
  /** 报价管理 */
  QuotationList: '/supply/inquiry_quotation/quotation/list',
  /** 质检报告 */
  CommodityQualityReportList: '/supply/commodity/quality_inspection/list',
  /** 询价单详情 */
  SupplyInquiryDetail: '/supply/inquiry_quotation/inquiry/detail',
  /** 询价列表 */
  SupplyAdminInquiryList: '/supply/inquiry_quotation/inquiry/list',
  /** 报价单列表 */
  SupplyQuotationList: '/supply/inquiry_quotation/quotation/list',
  /** 报价单详情 */
  SupplyQuotationDetail: '/supply/inquiry_quotation/quotation/detail',
  /** 报价单详情 */
  SupplyQuotationDetailByNo: '/supply/inquiry_quotation/quotation/detail_no',
  /** 报价单编辑 */
  SupplyQuotationUpdate: '/supply/inquiry_quotation/quotation/update',
  /** 报价单创建 */
  SupplyQuotationCreate: '/supply/inquiry_quotation/quotation/create',
  /** 报价单创建 */
  SupplyQuotationCreateByInquiry: '/supply/inquiry_quotation/quotation/create_by_inquiry',
  /** 报价单创建 */
  SupplyQuotationCreateByProject: '/supply/inquiry_quotation/quotation/create_by_project',
  /** 报价单复制 */
  SupplyQuotationCopy: '/supply/inquiry_quotation/quotation/copy',
  /** 新建采购合同 */
  SupplyPurchaserContractCreate: '/supply/purchase_contract/create',
  /** 采购合同列表 */
  SupplyPurchaserContractList: '/supply/purchase_contract/list',
  /**
   * 采购合同详情
   * @param string id 采购合同id
   * @description 使用方式 ${SupplyPurchaserContractDetail}/${id}
   * */
  SupplyPurchaserContractDetail: '/supply/purchase_contract/detail',
  /** 采购合同详情-通过编号查询 */
  SupplyPurchaserContractDetailByNo: '/supply/purchase_contract/detail_no',
  /**
   * 编辑采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${SupplyPurchaserContractEdit}/${id}
   * */
  SupplyPurchaserContractEdit: '/supply/purchase_contract/edit',
  SupplyPurchaserContractCopy: '/supply/purchase_contract/copy',
  /**
   * 折扣定价详情
   * @description 使用方式 ${SupplyDiscountPricesDetail}/${discountedPricingNo}
   * */
  SupplyDiscountPricesDetail: '/supply/inquiry_quotation/discount_price/detail',
  ReconciliationListForSupply: '/supply/bill/reconciliation/list',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetailForSupply}/${statementNo}
   * */
  ReconciliationDetailForSupply: '/supply/bill/reconciliation/detail',
  /** 采购单列表 */
  SupplyPurchaseOrderList: '/supply/purchase_order/list',
  /** 需方画像列表 */
  SupplyPurchaserPortraitList: '/supply/purchaser_portrait/list',
  /** 供方预警-质检报告缺失（采购单） */
  SupplyWarningQualityReportMissingList: '/supply/warning/quality_report_missing',
  /** 供方预警-差评采购单 */
  SupplyWarningBadReviewsPurchaseList: '/supply/warning/bad_reviews_purchase',
  /** 供方预警-逾期送达 */
  SupplyWarningOverdueDeliveryPurchaseList: '/supply/warning/overdue_delivery_purchase',
  /** 供方预警-少送错送 */
  SupplyWarningLessDeliveryPurchaseList: '/supply/warning/less_delivery_purchase',
  /** 供方预警-包装破损 */
  SupplyWarningDamagedPackagePurchaseList: '/supply/warning/damaged_package_purchase',
  /** 供方预警-温湿度不达标 */
  SupplyWarningTemperatureHumidityPurchaseList: '/supply/warning/temperature_humidity_purchase',
  /** 供方预警-健康证过期 */
  SupplyWarningHealthCertExpiredList: '/supply/warning/health_cert_expired',
  /** 采购单详情 */
  SupplyPurchaseOrderDetail: '/supply/purchase_order/detail',
  /** 采购汇总表 */
  SupplyPurchaseReportList: '/supply/report/purchase_report/list',
  /** 经营分析 */
  SupplyBusinessAnalysisList: '/supply/report/business_analysis/list',
  /** 采购需求汇总 */
  PurchaseRequireSummary: '/supply/purchase_order/summary/list',
  /** 应收汇总 */
  ReceivableSummary: '/supply/bill/receivable/list',
  /** 开票记录列表 */
  BillRecordList: '/supply/bill/bill_record/list',
  /** 开票记录详情 */
  BillRecordDetail: '/supply/bill/bill_record/detail',
  /** 开票记录创建 */
  BillRecordCreate: '/supply/bill/bill_record/create',
  /** 开票记录编辑 */
  BillRecordEdit: '/supply/bill/bill_record/edit',
  /** 角色创建 */
  SupplyRoleCreate: '/supply/role/create',
  /** 角色列表 */
  SupplyRoleList: '/supply/role/list',
  /**
   * 角色编辑
   * ?roleId=${id}
   * */
  SupplyRoleEdit: '/supply/role/editor',
  /** 车辆 */
  SupplyDeliveryCarList: '/supply/delivery_car/list',
  /** 配送任务 */
  SupplyDeliveryTaskList: '/supply/delivery_task/list',
  /** 新建配送任务 */
  SupplyDeliveryTaskCreate: '/supply/delivery_task/create',
  /** 编辑配送任务 */
  SupplyDeliveryTaskEdit: '/supply/delivery_task/edit',
  /** 配送任务详情 */
  SupplyDeliveryTaskDetail: '/supply/delivery_task/detail',
  /** 配送任务一键排线 */
  SupplyDeliveryTaskQuickWiring: '/supply/delivery_task/quick_wiring',
  /** 配送路线列表 */
  SupplyDeliveryRouteList: '/supply/delivery_route/list',
  /** 新建配送路线 */
  SupplyDeliveryRouteCreate: '/supply/delivery_route/create',
  /** 编辑配送路线 */
  SupplyDeliveryRouteEdit: '/supply/delivery_route/edit',
  /** 配送路线详情 */
  SupplyDeliveryRouteDetail: '/supply/delivery_route/detail',
  /** 监管方实时监控全屏 */
  SupplyRealtimeMonitor: '/supply/monitor/realtime_monitor',
  /** 监管方实时监控全屏 */
  SupplyRealtimeMonitorFullScreen: '/supply/monitor/realtime_monitor_full_screen',
  /** 工单 */
  SupplyWorkOrder: '/supply/platform/work_order/list',
  /** 平台对接 */
  SupplyPlatformDocking: '/supply/platform_docking',
  /** 平台对接详情 */
  SupplyPlatformDockingDetail: (id: number) => `/supply/platform_docking/detail?id=${id}`,
  /** 入库单详情 */
  SupplyInboundOrderDetail: '/supply/inventory/inbound_order/detail',
  /** 出库单详情 */
  SupplyOutboundOrderDetail: '/supply/inventory/outbound_order/detail',
  /** 货源管理 */
  SupplyInventorySourceManageList: '/supply/inventory/source_manage/list',
  /** 新建货源 */
  SupplyInventorySourceManageCreate: '/supply/inventory/source_manage/create',
  /** 编辑货源 */
  SupplyInventorySourceManageEdit: '/supply/inventory/source_manage/edit',
  /** 找货源 */
  SupplyInventorySourceManageFindList: '/supply/inventory/source_manage/find_list',
  /** 货源绩效 */
  SupplySourceManagePerformanceList: '/supply/source_manage/performance_list',
  /** 补货单列表 */
  SupplyInventoryReplenishmentOrderList: '/supply/inventory/replenishment_order/list',
  /** 补货单详情 */
  SupplyInventoryReplenishmentOrderDetail: '/supply/inventory/replenishment_order/detail',
  /** 补货单新建 */
  SupplyInventoryReplenishmentOrderCreate: '/supply/inventory/replenishment_order/create',
  /** 补货单编辑 */
  SupplyInventoryReplenishmentOrderEdit: '/supply/inventory/replenishment_order/edit',
  /** 供方数据大屏 */
  SupplyScreen: '/supply/screen',
  /** 补货单完成 */
  SupplyInventoryReplenishmentOrderComplete: '/supply/inventory/replenishment_order/complete',
  /** 补货退回单列表 */
  SupplyReplenishmentReturnList: '/supply/replenishment_return/list',
  /** 补货退回单新建 */
  SupplyReplenishmentReturnCreate: '/supply/replenishment_return/create',
  /** 补货退回单编辑 */
  SupplyReplenishmentReturnEdit: '/supply/replenishment_return/edit',
  /** 补货退回单完成 */
  SupplyReplenishmentReturnComplete: '/supply/replenishment_return/complete',
  /** 补货退回单详情 */
  SupplyReplenishmentReturnDetail: '/supply/replenishment_return/detail',
  /** 协议价列表 */
  SupplyReplenishmentPriceList: '/supply/replenishment_price/list',
  /** 新建协议价 */
  SupplyReplenishmentPriceCreate: '/supply/replenishment_price/create',
  /** 编辑协议价 */
  SupplyReplenishmentPriceEdit: '/supply/replenishment_price/edit',
  /** 协议价详情 */
  SupplyReplenishmentPriceDetail: '/supply/replenishment_price/detail',
  /** 复制协议价 */
  SupplyReplenishmentPriceCopy: '/supply/replenishment_price/copy',
  /** 补货规则 */
  SupplyReplenishmentRules: '/supply/inventory/replenishment_rules/list',
  /** 保质期记录 */
  SupplyShelfLifeRecordList: '/supply/inventory/shelf_life_record/list',
  /** 新建保质期记录 */
  SupplyShelfLifeRecordCreate: '/supply/inventory/shelf_life_record/create',
  /** 保质期跟踪 */
  SupplyShelfLifeTrackList: '/supply/inventory/shelf_life_track/list',
  /** 补货计划创建 */
  SupplyInventoryReplenishmentPlanCreate: '/supply/inventory/replenishment_plan/create',
  /** 委外验收列表 */
  SupplyOutsourceAcceptanceList: '/supply/outsource/acceptance/list',
  /** 库存回退 */
  SupplyInventoryRollbackList: '/supply/inventory/inventory_rollback/list',
  /** 商品预警 */
  SupplyProductWarningList: '/supply/inventory/product_warning/list',
  /** 新建盘点单 */
  SupplyInventorySheetAdd: '/supply/inventory/inventory_sheet/add',
  /** 投筐记录列表 */
  SupplyBasketDeliveryList: '/supply/basket_delivery/list',
  /** 投筐记录详情 */
  SupplyBasketDeliveryDetail: '/supply/basket_delivery/detail',
  /** 新建投筐记录 */
  SupplyBasketDeliveryCreate: '/supply/basket_delivery/create',
  /** 编辑投筐记录 */
  SupplyBasketDeliveryEdit: '/supply/basket_delivery/edit',
  /** 补货进度 */
  SupplyReplenishmentProgressList: '/supply/replenishment_progress/list',
  /** 补货成本 */
  SupplyReplenishmentCostList: '/supply/replenishment_cost/list',
  /** 分拣任务 */
  SupplySortTaskList: '/supply/sort_task/list',
  /** 新建仓库 */
  SupplyWarehouseCreate: '/supply/warehouse/create',
  /**
   * 编辑仓库
   * `/${id}` 为编辑
   * */
  SupplyWarehouseEdit: '/supply/warehouse/edit',
  /**
   * 库位分配规则
   * ?productCategoryId=${productCategoryId}&productCategoryName=${productCategoryName}
   * */
  SupplyPositionRules: '/supply/position_rules/list',
  /** 凭证类别列表 */
  SupplyVoucherCategoryList: '/supply/voucher_category/list',
  /** 分录规则列表 */
  SupplyEntryRuleList: '/supply/entry_rule/list',
  /** 部门列表 */
  SupplyDepartmentList: '/supply/department/list',
  /** 辅助核算列表 */
  SupplyAuxiliaryAccountingList: '/supply/auxiliary_accounting/list',
  /** 借贷科目列表 */
  SupplyDebitCreditSubjectList: '/supply/debit_credit_subject/list',
  /** 账套列表 */
  SupplyAccountBookList: '/supply/account_book/list',
  /** 账套总账 */
  SupplyAccountBookLedger: '/supply/account_book/ledger',
  /** 会计总账列表 */
  SupplyFinanceLedgerList: '/supply/finance_ledger/list',
  /** 凭证生成列表 */
  SupplyVoucherGenerateList: '/supply/voucher_generate/list',
  /** 记账凭证模版列表 */
  SupplyVoucherTemplateList: '/supply/voucher_template/list',
  /** 记账凭证列表 */
  SupplyVoucherList: '/supply/voucher/list',
  /** 新建记账凭证 */
  SupplyVoucherCreate: '/supply/voucher/create',
  /** 编辑记账凭证 */
  SupplyVoucherEdit: '/supply/voucher/edit',
  /** 记账凭证详情 */
  SupplyVoucherDetail: '/supply/voucher/detail',
  /** 经营计算器 */
  SupplyBusinessCalculatorList: '/supply/business_calculator/list',
  /** 下载 */
  SupplyDownloadInfoList: '/supply/download_info/list',
};
